import React, { useState, useRef } from 'react'
// import Nohmi1 from '../images/nohmi1.png'
import Nohmig from '../images/nohmig.png'
import { href, Link } from 'react-router-dom'
import { MdOutlineArrowOutward } from "react-icons/md";
// import { FaSearch } from "react-icons/fa";

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState(null)
  // const timeoutRef = useRef(null);
  let closeTimeout = null;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
    setActiveDropdown(null)
  }

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null)
    } else {
      setActiveDropdown(dropdown)
    }
  }

  const closeDropdowns = () => {
    setActiveDropdown(null)
  }
  
  const handleMouseEnter = (menu) => {
    clearTimeout(closeTimeout);
    // clearTimeout(timeoutRef.current); // Stop close timer
    setActiveDropdown(menu); // Open immediately
  };

  const handleMouseLeave = () => {
    closeTimeout = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };

  // const handleMouseLeave = () => {
  //   // Delay close by 2 seconds
  //   timeoutRef.current = setTimeout(() => {
  //     setActiveDropdown(null);
  //   }, 2000);
  // };

  // About Us dropdown items
  // const aboutUsItems = [
  //   { title: 'Our Story', href: '/about' },
  //   { title: 'Leadership Team', href: '/about' },
  //   { title: 'Mission & Vision', href: '/about' },
  //   { title: 'Certifications', href: '/about/certifications' },

  // ]

  // Products dropdown with categories and subcategories

  const productsItems = [
    {
      category: 'Fire Alarm System',
      items: [
        { title: 'Addressable Systems', href: '/address' },
        { title: 'Integlex Fire Alarm Control(N3060)', href: '/N3060' },
        { title: 'Integlex Fire Alarm Control(N765)', href: '/N765' },
        { title: 'Common Devices', href: '/Other' },
        { title: 'Aspiration Smoke Detection System', href: '/Smoke' },
        { title: 'IR3 Flame Detectors', href: '/flame' }
      ]
    },
    {
      category: 'Gas Suppression System',
      items: [
        { title: 'NN100 Clean Agent', href: '/NN100' },

      ]
    },
    {
      category: 'Foam Extinguishing System',
      items: [
        { title: 'Low Expansion Foam', href: '/Foam' },
        { title: 'High Expansion Foam', href: '/FoamM' },
      ]
    }
  ]

  return (
    <div>
      <div className='border-[3px] border-green-700'></div>
      <nav className='bg-white shadow-lg'>
        <div className='max-w-7xl mx-auto px-4 md:px-6 lg:px-6'>
          <div className='flex justify-between items-center h-16'>
            {/* Logo */}
            <div className='flex-shrink-0'>
              <Link to='/' className='flex items-center space-x-2'>
                <img src={Nohmig} alt="Nohmi Logo" className='h-6 w-auto' />
                <h1 className='text-gray-700 font-semibold  hidden sm:block'>
                  Nohmi Bosai (India) Pvt. Ltd.
                </h1>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className='hidden lg:flex items-center space-x-8 font-semibold'>
              <Link to='/' className='text-gray-700 hover:text-green-700 transition-colors duration-200'>
                Home
              </Link>

              {/* About Us Dropdown */}
              <div className='relative group' onMouseEnter={() => setActiveDropdown('about')}
                onMouseLeave={closeDropdowns}>
                <Link to='/about'>
                  <button
                    className='flex items-center text-gray-700 hover:text-green-700 transition-colors duration-200'
                    onMouseEnter={() => setActiveDropdown('about')}
                  >
                    About Us
                    {/* <svg className='ml-1 h-4 w-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                  </svg> */}
                  </button>
                </Link>
                {/* <div 
                  className={`absolute top-full left-0 mt-1 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50 transition-all duration-200 ${
                    activeDropdown === 'about' ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}
                  onMouseLeave={closeDropdowns}
                > */}
                {/* <div className='py-2'>
                    {aboutUsItems.map((item, index) => (
                      <Link
                        key={index}
                        to={item.href}
                        className='block px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-200'
                      >
                        {item.title}
                      </Link>
                    ))}
                  </div> */}
                {/* </div> */}
              </div>

              {/* Products Dropdown */}
              <div className='relative group' onMouseEnter={() => handleMouseEnter("products")}
                onMouseLeave={handleMouseLeave}>
                <Link to='/products'>
                  <button
                    className='flex items-center text-gray-700 hover:text-green-700 transition-colors duration-200'
                    onMouseEnter={() => setActiveDropdown('products')}
                  >
                    Products
                    <svg className='ml-1 h-4 w-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                    </svg>
                  </button>
                </Link>
                <div
                  className={`absolute top-full left-0 mt-3 w-80 bg-white rounded-md shadow-lg border border-gray-200 z-50 transition-all duration-200 ${activeDropdown === 'products' ? 'opacity-100 visible' : 'opacity-0 invisible'
                    }`}
                  // onMouseLeave={closeDropdowns}
                >
                  <div className='grid grid-cols-1 gap-1 py-2'>
                    {productsItems.map((category, categoryIndex) => (
                      <div key={categoryIndex} className='group/category relative'>
                        <div className='px-4 py-2 text-sm font-semibold text-gray-800 bg-gray-50'>
                          {category.category}
                        </div>
                        <div className='pl-6'>
                          {category.items.map((item, itemIndex) => (
                            <Link
                              key={itemIndex}
                              to={item.href}
                              className='block px-4 py-2 text-sm text-gray-600 hover:bg-green-50 hover:text-green-700 transition-colors duration-200'
                            >
                              {item.title}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <Link to='/blog1' className='text-gray-700 hover:text-green-700 transition-colors duration-200'>
                Blog
              </Link>
              <Link to='/events' className='text-gray-700 hover:text-green-700 transition-colors duration-200'>
                Gallery
              </Link>
              <Link to='/contact' className='text-gray-700 hover:text-green-700 transition-colors duration-200'>
                Contact Us
              </Link>
            </div>

            {/* Get In Touch Button - Desktop */}
            <div className="hidden lg:flex items-center space-x-3">
              {/* <span className='text-green-700 font-bold'><FaSearch /></span> */}
              <Link to="/contact">
                <button className="flex items-center gap-2 bg-green-700 text-white px-6 py-2 rounded-md hover:bg-green-800 transition-colors duration-200 font-semibold">
                  Get in Touch <MdOutlineArrowOutward />
                </button>
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className='lg:hidden'>
              <button
                onClick={toggleMobileMenu}
                className='text-gray-700 hover:text-green-700 focus:outline-none'
              >
                <svg className='h-6 w-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  {isMobileMenuOpen ? (
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
                  ) : (
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className='lg:hidden bg-white border-t border-gray-200'>
              <div className='px-2 pt-2 pb-3 space-y-1'>
                <Link
                  to='/'
                  className='block px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Home
                </Link>

                <Link
                  to='/about'
                  className='block px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  About
                </Link>

                {/* Mobile About Us Dropdown */}
                {/* <div>
                  <button
                    onClick={() => toggleDropdown('about')}
                    className='w-full flex justify-between items-center px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  >
                    About Us */}
                {/* <svg 
                      className={`h-4 w-4 transition-transform duration-200 ${
                        activeDropdown === 'about' ? 'rotate-180' : ''
                      }`} 
                      fill='none' 
                      stroke='currentColor' 
                      viewBox='0 0 24 24'
                    >
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                    </svg> */}
                {/* </button> */}
                {/* {activeDropdown === 'about' && (
                    <div className='pl-6 mt-1 space-y-1'>
                      {aboutUsItems.map((item, index) => (
                        <Link
                          key={index}
                          to={item.href}
                          className='block px-3 py-2 text-sm text-gray-600 hover:text-green-700 hover:bg-gray-50 rounded-md'
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          {item.title}
                        </Link>
                      ))}
                    </div>
                  )}
                </div> */}

                {/* Mobile Products Dropdown */}
                <div>
                  <Link to='/products'>
                    <button
                      onClick={() => toggleDropdown('products')}
                      className='w-full flex justify-between items-center px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                    >
                      Products
                      <svg
                        className={`h-4 w-4 transition-transform duration-200 ${activeDropdown === 'products' ? 'rotate-180' : ''
                          }`}
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                      </svg>
                    </button>
                  </Link>
                  {activeDropdown === 'products' && (
                    <div className='pl-6 mt-1 space-y-2'>
                      {productsItems.map((category, categoryIndex) => (
                        <div key={categoryIndex}>
                          <div className='px-3 py-1 text-sm font-semibold text-gray-800 bg-gray-100 rounded'>
                            {category.category}
                          </div>
                          <div className='pl-3 space-y-1'>
                            {category.items.map((item, itemIndex) => (
                              <Link
                                key={itemIndex}
                                to={item.href}
                                className='block px-3 py-1 text-sm text-gray-600 hover:text-green-700 hover:bg-gray-50 rounded-md'
                                onClick={() => setIsMobileMenuOpen(false)}
                              >
                                {item.title}
                              </Link>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <Link
                  to='/blog1'
                  className='block px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Blog
                </Link>
                <Link
                  to='/events'
                  className='block px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Gallery
                </Link>
                <Link
                  to='/contact'
                  className='block px-3 py-2 text-base font-medium text-gray-700 hover:text-green-700 hover:bg-gray-50 rounded-md'
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>

                {/* Mobile Get In Touch Button */}
                <div className='mt-4'>
                  <Link to='/contact'>
                    <button className='w-full bg-green-700 text-white px-6 py-2 rounded-md hover:bg-green-800 transition-colors duration-200'>
                      Get in Touch
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>
    </div>
  )
}

export default Navigation